<template>
  <div>
    <CalendarOv />

    <VacationPlanEmployee />
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import CalendarOv from '../components/CalendarOv.vue'
import VacationPlanEmployee from '../components/VacaltionPlanEmployee.vue'



export default {
  components: {
    CalendarOv,
    VacationPlanEmployee,
  },
  computed: {
    ...mapGetters(['getIsLoading']),

  },
}

</script>
